/** Defines a provider for progress updates. */
export interface Progress<T> {

  /**
   * Reports a progress update.
   * @param value The value of the updated progress.
   */
  report(value: T): void;
}
